export default __webpack_public_path__ + "static/media/virtualpad_pad_l.c182395a.png";